import events from '@/events.js'
const ce = events['career-expo'].options;
const id = events['interviewing-days'].options;

/* eslint-disable dot-notation */
export default {
  'major-exposure': {
    id: 'major-exposure',
    name: 'Major Exposure Module',
    description: `
    <div class="row">
    <div class="col-md-6">
    Career Expo
    ${ce['normal-stand'].description}
    </div>
    <div class="col-md-6">
    Interviewing Days (choose at least one option)
    <ul>
    <li>Interview €450</li>
    <li>Lunch €550</li>
    <li>Dinner & Drink €600</li>
    <li>Company Case €550</li>
    </ul>
    </div>
    </div>
    `,
    price: 1950,
    includes: {
      'career-expo': [
        {
          option: ce['normal-stand']
        }
      ],
      'interviewing-days': []
    },
    options: {
      'career-expo': [
        {
          option: ce['experience-center']
        },
        {
          option: ce['speed-dates']
        },
        {
          option: ce['extra-employee'],
          max: 5
        },
        {
          option: ce['extra-table'],
          max: 2
        },
        {
          option: ce['extra-barstool'],
          max: 5
        }
      ],
      'interviewing-days': [
        {
          option: id['interview'],
          max: 4
        },
        {
          option: id['lunch'],
          max: 4
        },
        {
          option: id['dinner-drink'],
          max: 4
        },
        {
          option: id['company-case'],
          max: 4
        }
      ]
    },
  },
  'medium-exposure': {
    id: 'medium-exposure',
    name: 'Medium Exposure Module',
    description: `
    Career Expo
    ${ce['normal-stand'].description}
    `,
    price: 1950,
    includes: {
      'career-expo': [
        {
          option: ce['normal-stand']
        }
      ]
    },
    options: {
      'career-expo': [
        {
          option: ce['experience-center']
        },
        {
          option: ce['speed-dates']
        },
        {
          option: ce['extra-employee'],
          max: 5
        },
        {
          option: ce['extra-table'],
          max: 2
        },
        {
          option: ce['extra-barstool'],
          max: 5
        }
      ],
    }
  },
  'modest-exposure': {
    id: 'modest-exposure',
    name: 'Modest Exposure Module',
    description: `
    Career Expo
    <ul>
    <li>Stand of 6 m<sup>2</sup></li>
    <li>1 standing table</li>
    <li>2 barstools</li>
    <li>2 employees(incl. lunch)</li>
    <li>1 parking ticket</li>
    </ul>
    `,
    price: 900,
    includes: {
      'career-expo': [
        {
          option: ce['small-stand']
        }
      ]
    },
    options: {
      'career-expo': [
        {
          option: ce['speed-dates']
        },
        {
          option: ce['extra-employee'],
          max: 2
        },
        {
          option: ce['extra-table'],
          max: 1
        },
        {
          option: ce['extra-barstool'],
          max: 3
        }
      ],
    }
  },
  'indepth-exposure': {
    id: 'indepth-exposure',
    name: 'In-Depth Exposure Module',
    description: `
    Interviewing Days (choose at least one option)
    <ul>
    <li>Interview €450</li>
    <li>Lunch €550</li>
    <li>Dinner & Drink €600</li>
    <li>Company Case €550</li>
    </ul>
    `,
    price: 500,
    includes: {
      'interviewing-days': []
    },
    options: {
      'interviewing-days': [
        {
          option: id['interview'],
          max: 4
        },
        {
          option: id['lunch'],
          max: 4
        },
        {
          option: id['dinner-drink'],
          max: 4
        },
        {
          option: id['company-case'],
          max: 4
        }
      ]
    },
  },
};